import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import '../../css/LoginForm.css';

import { FormWithConstraints, FieldFeedback } from 'react-form-with-constraints';
import { FieldFeedbacks, FormGroup, LabelWithFormControlStyle, FormControlLabel, FormControlInput ,Button } from 'react-form-with-constraints-bootstrap4';
import HmAjax from '../../util/HmAjax';
import NativeAjax from '../../util/NativeAjax';
import UserStore from '../../util/UserStore';
import { isMobile, isTablet, isBrowser  } from 'react-device-detect';
import $ from 'jquery';
import countries from '../../views/purchase/countries.json';
import Select from 'react-select';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';
import TestTakingModalComponent from '../../views/plp/TestTakingModalComponent';
import OrderReview from '../../views/purchase/OrderReview';
import HmEventRegistry from '../../model/HmEventRegistry';
import { Label, Input } from 'reactstrap';

var paymentErrorMap = {
	"TXN_ERR_001": "Transaction not saved",
	"TXN_ERR_002":"Transaction failed",
	"TXN_ERR_003":"Field does not meet the minimum length",
	"TXN_ERR_004":"Field exceeds the maximum length",
	"TXN_ERR_005":"Space not allowed in the field",
	"TXN_ERR_006":"Should be Alphanumeric Only",
	"TXN_ERR_007":"Should contain Alphanumeric and permitted characters only",
	"TXN_ERR_008":"Should contain Alphabets Only",
	"TXN_ERR_009":"Should contain Numbers Only",
	"TXN_ERR_010":"Should contain Numbers and dot (.)",
	"TXN_ERR_011":"Contains Invalid Characters",
	"TXN_ERR_012":"Should contain Alpabets and characters only",
	"TXN_ERR_013":"Invalid parameter",
	"TXN_ERR_014":"Invalid Transaction amount",
	"TXN_ERR_015":"System Error"
};


const MOBILE_VALID_LENGTH = {
	"SGD":8,
	"INR":10
}

const MOBILE_VALID_LENGTH_BY_GEO = {
	"IN":10,
	"SG":8,
	"ALL":8
};

class BillingForm extends PreLoginPage {

	constructor(props) {
		super(props);
		
		//ModalContent has 2 options - billing / review
		this.state = {				
			ModalShow:false,
			ModalContent:"billing", 
			prod_price : "",
			taxAmount: "",
			basePrice:"", 
			otherCharges:"",
			prod_name: "",
			errorMsg:"",
			selectedProductClassName:"",
			selectedProductCategoryType:"",
			sessionId:"",
			eligible:false,
			isverified:false,
			billing_userid:"",
			existing_userid:false,
			billing_name:"",
			billing_address:"",
			billing_zipcode:"",
			billing_city:"",
			billing_state:"",
			billing_email:"",
			billing_phone:"",
		}
		this.oldState = this.state;

		this.userId = null;
		this.userCountryCode = null;
		this.purchaseObj = props.purchaseObj || {};
		this.userObj = {};
		this.productsJson = props.productsJson || {};
		
		this.renderProductDetails = this.renderProductDetails.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);

		this.submitForm = this.submitForm.bind(this);
		this.countryDropdownChange = this.countryDropdownChange.bind(this);
		this.updatePrice = this.updatePrice.bind(this);
		this.hideReviewModal = this.hideReviewModal.bind(this);
		
		this.validateMobilePattern = this.validateMobilePattern.bind(this);

		this.payload = {};

		this.proceedPay = this.proceedPay.bind(this);
		this.countryDpList = [];
		this.taxRules = {};
		this.productCategoryInfo = {
			"PLP":"PLP",
			"EXAM_PREP_CBSE":"EXAM_PREP_CBSE",
			"SPL":"SPL" ,
			"PLP-GA":"PLP",
			"EXAM_PREP_CBSE-GA":"CBSE Exam Prep",
			"SPL-GA":"SPL"
		}
		this.userDataKey = "USER_SESSION";
		this.appName = null;
		this._appId = null;
		//this.selectedCountryOption = this.countryDpList[0];

		this.renderForm = this.renderForm.bind(this);
		this.renderHiddenForm=this.renderHiddenForm.bind(this);
		this.getUserStatus = this.getUserStatus.bind(this);
		
	}

	componentWillUnmount(){
		this.resetValues();
	}

	resetValues(){
		this.setState(this.oldState);
	}

	validateMobilePattern(){
		const selectedCurr = (this.purchaseObj && this.purchaseObj.currency) ? this.purchaseObj.currency : "INR";

		let mobileLen = 10;
		
		const geo = this.getGeo();

		if(geo && (!isNaN(MOBILE_VALID_LENGTH_BY_GEO[geo.toUpperCase()]) || !isNaN(MOBILE_VALID_LENGTH_BY_GEO["ALL"]))){
			mobileLen = MOBILE_VALID_LENGTH_BY_GEO[geo.toUpperCase()] || MOBILE_VALID_LENGTH_BY_GEO["ALL"];
		}else if(selectedCurr && !isNaN(MOBILE_VALID_LENGTH[selectedCurr])){
			mobileLen = MOBILE_VALID_LENGTH[selectedCurr];
		}

		return ".{"+mobileLen+",}";		
	}


	handleChange(e) {
		var me=this;
		const target = e.currentTarget;	
		this.form.validateFields(target);
		
		if(target.name=="billing_userid" && this.state.isverified){
			me.setState({eligible:false,isverified:false});
		}

		this.setState({
			[target.name]: target.value,
			submitButtonDisabled: !this.form.isValid()
		});
	}

	toggleChange = () => {
    this.setState({
			existing_userid: $('#existing_userid').prop('checked'),
			eligible:false,
			isverified:false
		});
  }


	handleSubmit(e) {
		e.preventDefault();

		this.form.validateFields();

		this.setState({ submitButtonDisabled: !this.form.isValid() });

		if (this.form.isValid() && this.state.eligible) { 
			this.submitForm();  
		}else if(!this.state.eligible) { 
			this.setState({serverMessage:this.rb("tchr.userid.verify")});
		}

		//this.showOrderReview();
	}

	submitForm = function(){
		var me =this;	
		var userExists = String(me.state.existing_userid);
		//console.log("userExists ==> ",userExists, "type : ",typeof userExists);
		//Setting payLoad
		me.payload={"schoolId":me.purchaseObj.productCategory,"validTo":me.purchaseObj.validTo,"userName":me.state.billing_name,"userExists":userExists,"role":"TCHR","grade":"TCHR"};

		var payloadStr = JSON.stringify(me.payload);
		//abdul
		var formData = {
			userName:this.state.billing_name,
			userId:this.state.billing_userid.toLowerCase(),
			appName:this.purchaseObj.appName,
			_appId:this.purchaseObj.appId,
			sessionId:this.state.sessionId,
			fullName:this.state.billing_name,
			address:this.state.billing_address,
			zip:this.state.billing_zipcode,
			city:this.state.billing_city,
			state:this.state.billing_state, 		
			countryCode: this.state.selectedCountryOption.value || "",			
			country: this.state.selectedCountryOption.label || "",	
			email: this.state.billing_email,
			phone:this.state.billing_phone,
			language:'EN',
			productList:[{
			"productId":me.purchaseObj._productID,
			"productCategory":me.purchaseObj.productCategory,
			"price":me.purchaseObj.productPrice,
			"currency":me.purchaseObj.currency,
			"validity":me.purchaseObj.validity,
			"tariffId":me.purchaseObj.productTariffID,
			"count":1
			}],
			currency:this.purchaseObj.currency,
			payload:payloadStr
		}

		var productList=[{
			"productId":me.purchaseObj._productID,
			"productCategory":me.purchaseObj.productCategory,
			"price":me.purchaseObj.productPrice,
			"currency":me.purchaseObj.currency,
			"validity":me.purchaseObj.validity,
			"tariffId":me.purchaseObj.productTariffID,
			"count":1
			}]
		
		// var productList=[{
		// 	"productId":me.purchaseObj.productid,
		// 	"productCategory":me.productsJson[me.purchaseObj.productid].productCategory,
		// 	"price":me.productsJson[me.purchaseObj.productid].pricing_details[me.purchaseObj.tarrrifid].productPrice,
		// 	"currency":me.productsJson[me.purchaseObj.productid].pricing_details[me.purchaseObj.tarrrifid].currency,
		// 	"validity":"1 year",
		// 	"tariffId":me.purchaseObj.tarrrifid,
		// 	"count":1
		// }];

		var opsCart = Object.assign({}, formData, { productList: JSON.stringify(productList) });
		var submitFormFields = opsCart;
		var paymentSubmitElem = $('#doPayForm');
		me.fillForm(paymentSubmitElem, submitFormFields);
		
		$.ajax({
			url: this.getUrlFor("OPS_FORM_VALIDATION"),
			data: $(paymentSubmitElem).serializeArray(),
			type: 'POST',
			xhrFields: {
				withCredentials: true
			},
			crossDomain: true,
			success: function(response){
				if(response !== null){
					if(response.formValid){
						me.setState({serverMessage:''});
	    					//me.doPay();
	    					me.showOrderReview();
	    				}				
	    				else if(response.errorMsgs != null){
	    					var errmsg = "";								
	    					if(response.fieldErrMap != null){
	    						for(var key in response.fieldErrMap){
	    							var msg = paymentErrorMap[response.fieldErrMap[key].split(":")[0]];		              
	    							errmsg += key +" : " + msg;
	    						}
	    					}
	    					me.setState({serverMessage:errmsg});

	    				}else{
	    					me.setState({serverMessage:'Sorry, we\'re unable to process your registration. Please try again later.'});
	    				}
	    			}

	    			//console.log("response : ", response);
	    		},
	    		error: function(response){
	    			console.log("Error in OPS_FORM_VALIDATION");
	    		}
	    	});

	}

	proceedPay(){
		this.doPay();
	}
	
	doPay(){
		var me =this;
		
		var payloadStr = JSON.stringify(me.payload);
		this.trackMe();
		var formData = {
			userId:this.state.billing_userid.toLowerCase(),
			/*customerId: me.userId,*/
			appName:me.purchaseObj.appName,
			_appId:me.purchaseObj.appId,
			sessionId:this.state.sessionId,
			fullName:this.state.billing_name,					
			address:this.state.billing_address,					
			zip:this.state.billing_zipcode,					
			city:this.state.billing_city,					
			state:this.state.billing_state, 					
			countryCode:this.state.selectedCountryOption.value || "",				
			country:this.state.selectedCountryOption.label || "",	
			email:this.state.billing_email,
			phone:this.state.billing_phone,
			billingAddressLine1:this.state.billing_address,					
			billingAddressLine2:this.state.billing_address,	
			language:"EN", 
			currency:me.purchaseObj.currency,
			payload: payloadStr					
		}
		
		var productList=[{
			"productId":me.purchaseObj._productID,
			"productCategory":me.purchaseObj.productCategory,
			"price":me.purchaseObj.productPrice,
			"currency":me.purchaseObj.currency,
			"validity":me.purchaseObj.validity,
			"tariffId":me.purchaseObj.productTariffID,
			"count":1
		}];

		
		var opsCart = Object.assign({}, formData, { productList: JSON.stringify(productList) });
		var submitFormFields = opsCart;
		var paymentSubmitElem = $('#doPayForm');
		me.fillForm(paymentSubmitElem, submitFormFields);
		$("#paySubmit").trigger("click");

		try{
			var trackGradeId = localStorage.getItem("grade") || "";
			this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"pay-gateway-class-"+trackGradeId});
		}catch(e){
			console.error(e);
		}
		
		return;
		
		//new HmAjax(this.getUrlFor("OPS_DO_PAY"),fd,headers).post(callBackSuccess,callBackFailure);
	}
	trackMe(){
		try{
			var trackObj = {
				"grade_id": localStorage.getItem("grade"),
				"product_type": this.productsJson[this.purchaseObj.productid].productCategory,
				"tariff_id": this.purchaseObj.productTariffID,
				"email": this.state.billing_email
			}

			this.initiateTrack("purchase_initiated",trackObj);
		}catch(e){}
	}
	componentWillUnmount(){
		$("#custom_fc_button").css("display","block");
			//console.log("componentWillUnmount")
			//$("body").css({overflowY:"auto"});
	}
	
	getOPSHome(){
		
		var me =this;
		//console.log(me.productsJson,me.purchaseObj.tarrrifid,me.purchaseObj.productid);
		//console.log(me.productsJson[me.purchaseObj.productid]);

		if(me.purchaseObj){

			//IMPORTANT: This component needs to be extended to make the following parameters dynamic
			var formData = {				
			/*customerId: me.userId,*/
			appName:me.purchaseObj.appName,
			_appId:me.purchaseObj.appId,
			/*sFrame: me.getUrlFor("PAYMENT_SUCCESS_URL"),*/
			sFrame: me.getUrlFor("TCHR_PURCHASE_SUCCESS"),
			fFrame: me.getUrlFor("PAYMENT_FAILURE_URL"),
			//pcsUrl: me.getUrlFor("PAYMENT_PCS_URL"), 
			pcsUrl: me.getUrlFor("TEACHER_PCS_URL"),
			//pcfUrl: me.getUrlFor("PAYMENT_PCF_URL"),
			pcfUrl: me.getUrlFor("TEACHER_PCF_URL"),
			currency: me.purchaseObj.currency					
		}
		var productList=[{
			"productId":me.purchaseObj._productID,
			"productCategory":me.purchaseObj.productCategory,
			"price":me.purchaseObj.productPrice,
			"currency":me.purchaseObj.currency,
			"validity":me.purchaseObj.validity,
			"tariffId":me.purchaseObj.productTariffID,
			"count":1
		}];
		
		
		var opsCart = Object.assign({}, formData, { productList: JSON.stringify(productList) });
		
		var me = this;
			
		$.ajax({
			url: this.getUrlFor("OPS_PROCESSPAY"),
			data: opsCart,
			type: 'POST',
			xhrFields: {
				withCredentials: true
			},
			crossDomain: true,
			success: function(response){
				
				if(response != null){	    				
	    				//alert("sessionid="+response.sessionId)
	    				me.setState({sessionId:response.sessionId});
	    				if (response.currency) {    		           

	    					if(response.allTaxRules && response.allTaxRules.length > 0){
	    						for(var i=0; i<response.allTaxRules.length; i++){
	    							var tempObj = {};
	    							if(me.taxRules[response.allTaxRules[i].geo]){
	    								tempObj = me.taxRules[response.allTaxRules[i].geo];
	    							}
	    							tempObj[response.allTaxRules[i].currency] = response.allTaxRules[i];

	    							me.taxRules[response.allTaxRules[i].geo] = tempObj;
	    						}
	    					}

	    					me.setState({sessionId:response.sessionId,opsReady:true,opsCheckDone:true});

	    					me.updatePrice();
	    				} else {
	    					me.setState({opsReady:false,opsCheckDone:true,errorMsg:'Sorry, we\'re unable to process your registration. Please try again later.'});    		           

	    				}
	    				
	    			}	    	
	    			//console.log("response : ", response);
	    		},
	    		error: function(response){
	    			console.log("Error in OPS_PROCESSPAY");
	    			me.setState({opsReady:false,opsCheckDone:true,errorMsg:'Sorry, we\'re unable to process your registration. Please try again later.'});    		     
	    		}
	    	});
		}
		//new HmAjax(this.getUrlFor("OPS_PROCESSPAY"),opsCart,headers).post(callBackSuccess,callBackFailure);
	}

	componentDidMount(){
		if(this.purchaseObj){
			console.log("tchr products ",this.purchaseObj);
			this.getOPSHome();
		}
	
		this.sessionCheck();
		this.populateCountryDropdown();	
		HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
		$("#custom_fc_button").css("display","none");
	} 
	
	getTaxedAmount(amount, country, currency){
		//console.log(amount, country, currency);
		var me = this;		
		amount = parseInt(amount);
		
		var taxAmount = 0;
		var basePrice = 0;
		var otherCharges = 0;
		var amountDetails = {taxAmount:0,basePrice:0,otherCharges:0,amount:amount};
		
		try{
			if(!isNaN(amount) && amount > 0 && currency && ((me.taxRules[country] && me.taxRules[country][currency]) || me.taxRules["ALL"] && me.taxRules["ALL"][currency])){
				
				var tRule =   ((me.taxRules &&  me.taxRules[country] &&  me.taxRules[country][currency]) ?   me.taxRules[country][currency] : null ) || ((me.taxRules &&  me.taxRules["ALL"] &&  me.taxRules["ALL"][currency]) ? me.taxRules["ALL"][currency] : null);
				otherCharges = tRule.flat;
				
				if(!tRule){
					return amount;
				}
				
				if(tRule.inclusive){
					if(tRule.type === 2){
						basePrice = Math.round((amount - otherCharges) * 100 / (100 + tRule.percentage)  *100) / 100;
						taxAmount = Math.round((amount - basePrice) * 100) / 100;
					}else{
						basePrice = Math.round(amount * 100 /  (100 + tRule.percentage)  * 100) / 100 - otherCharges;
						taxAmount = Math.round((amount - basePrice) * 100) / 100 ;
					}
				}else{
					//Exclusive tax - amount without tax is the basePrice
					basePrice = amount;
					
					if(tRule.type === 1){
						taxAmount = Math.round(amount *  tRule.percentage/100) + otherCharges;
						amount = amount + taxAmount;
					}else if(tRule.type === 2){
						taxAmount =  Math.round((amount + otherCharges) *  tRule.percentage/100)
						amount = amount + taxAmount;
					}else{
						taxAmount = Math.round(amount *  tRule.percentage/100)
						amount = amount + taxAmount;
					}
				}
				
				amountDetails["taxAmount"] = taxAmount;
				amountDetails["basePrice"] = basePrice;
				amountDetails["otherCharges"] = otherCharges; 
				amountDetails["amount"] = amount;
				
				
				me.setTaxMessage('Price inclusive of Taxes', 'Price updated to include Taxes', amount);
			}else{
				me.setTaxMessage('Price includes 0% Taxes', null, amount);
			}
		}catch(e){}
		
		return amountDetails;
	}
	setTaxMessage(msg1, msg2, amount) {
		var taxMessage1Elem = $('#tax-message-1');
		var taxMessage2Elem = $('#tax-message-2');

		this.setState({taxMsg1:""});
		this.setState({taxMsg2:""});
		if (typeof msg1 === 'string' && msg1.length > 0) {
			this.setState({taxMsg1:msg1});
		}
		if (typeof msg2 === 'string' && msg2.length > 0) {
			this.setState({taxMsg2:msg2});
		}
	}
	
	fillForm(formElem, formData, reset) {
		var i;
		for (i in formData) {
			$(formElem).find('[name="' + i + '"]').val(reset ? '' : formData[i]);
		}
	}
	
	populateCountryDropdown() {     
		var defaultIndex = 0;
		for (var i = 0; i < countries.countryList.length; i++) {          
			this.countryDpList.push({"label":countries.countryList[i].countryName,"value":countries.countryList[i].countryID});

			if(this.userCountryCode){
				if(countries.countryList[i].countryID == this.userCountryCode){
					defaultIndex = i;
				}
			}         
			else if(countries.countryList[i].countryName.toLowerCase() == "india"){
				defaultIndex = i;
			}
		}
        //this.selectedCountryOption = this.countryDpList[0];
        this.setState({selectedCountryOption:this.countryDpList[defaultIndex]});
       // console.log("country::",this.state.selectedCountryOption);
   }
   countryDropdownChange(selectedOption){
    	//this.selectedCountryOption = selectedOption;
    	
    	var me = this;
    	this.setState({selectedCountryOption:selectedOption});

    	setTimeout(function() {
    		me.updatePrice();
    	},200);
    	
    }
    updatePrice(){
    	HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
    	if(this.state.selectedCountryOption === null)
    	{
    		return false;
    	}
    	//console.log("updateprice::",this.state.selectedCountryOption);
    	
    	var validity = (this.purchaseObj.validity	== "365") ? "1 Year" : this.purchaseObj.validity;
    	var price = this.purchaseObj.productPrice;
    	var currency = this.purchaseObj.currency;
    	var amountDetails = this.getTaxedAmount(price,this.state.selectedCountryOption.value,currency); 
    	var taxAmount = amountDetails.taxAmount;
    	var totalAmount = amountDetails.amount;
    	var otherCharges = amountDetails.otherCharges;
    	var basePrice = amountDetails.basePrice;
    	var productName = this.purchaseObj.productName;
    	//console.log("amountDetails:::",amountDetails);
    	this.setState({prod_validity: validity,
    		prod_price : totalAmount,
    		taxAmount: taxAmount,
    		prod_name: productName,
    		basePrice:basePrice, otherCharges:otherCharges});
		}
		
		
    hideReviewModal(){
    	this.setState({"ModalContent":"billing"});

			//this.setState({"ModalShow":false});
		}

		 getUserStatus(){
			if(this.state.billing_userid.length<=0){
				return;
			} 

			var pattern = new RegExp("^[a-z0-9\s]+$");
			if(!pattern.test(this.state.billing_userid)){
				return;
			}
			
			var formData = {
				"userId":this.state.billing_userid.toLowerCase()
			}
	
			var me =this;
		//	me.setState({submitButtonDisabled: true});
			var callBackSuccess = function(response, request){
				
				if(response !== null){

				if(!me.state.existing_userid){
					if(!response.userExists){
						me.setState({serverMessage:'',eligible:true,isverified:true});
					}else if(response.userExists){
						me.setState({submitButtonDisabled: false,eligible:false,isverified:true});
					}
				}else if(me.state.existing_userid){
					if(response.userExists){
						me.setState({serverMessage:'',eligible:true,isverified:true});
					}else if(!response.userExists){
						me.setState({submitButtonDisabled: false,eligible:false,isverified:true});
					}
				}
				// if(response.userExists && response.source!=='null' && response.message !== "provider_forbidden"){	
				// 	if(response.source=="lumos"){
				// 		me.setState({userLoginAllowed:true,user_exists:response.userExists,source:response.source,username:me.state.billing_userid});
				// 	}else if(response.source=="plp"){
				// 		me.setState({userLoginAllowed:true,user_exists:response.userExists,source:response.source,userInput:me.state.billing_userid});
				// 	}
				// }else{	
				// 	if(response.message == "provider_forbidden"){						
				// 		if(response.authProviderId==2){
				// 			me.setState({submitButtonDisabled: false, serverMessage: me.rb("google.errmsg.pwd")});
				// 		}else if(response.authProviderId==4){
				// 			me.setState({submitButtonDisabled: false, serverMessage: me.rb("uolo.errmsg.pwd")});
				// 		}
				// 	}else{					
				// 		me.setState({submitButtonDisabled: false, serverMessage: me.rb("unifiedlogin.invalidinput.msg")});
				// 	}					
				// }
			}
			}
	
			var PLPcallBackFailure = function(response, request){
				me.setState({submitButtonDisabled: false});
			}

			var callBackFailure = function(response, request){
				//me.setState({submitButtonDisabled: false});
				new NativeAjax(me.getUrlFor("PLP_GET_USER_STATUS_UNIF"),formData).enableCORS().post(callBackSuccess, PLPcallBackFailure);
			}

			
	
			//new HmAjax(this.getUrlFor("GET_USER_STATUS"),formData).post(callBackSuccess,callBackFailure);
			new NativeAjax(this.getUrlFor("GET_USER_STATUS_UNIF"),formData).enableCORS().post(callBackSuccess, callBackFailure);
			
		}
		checkValidUserInput(){
			var me = this;
			var userinput = this.state.billing_userid;
			var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
			
			if(phoneRegx.test(userinput)){			
				if(userinput.length == 10){				
					me.setState({userLoginAllowed:false});
					me.props.showSignUp(me.state.loginType,me.state.billing_userid,me.props.from);
				}else{
					me.setState({submitButtonDisabled: false, serverMessage: me.rb("login.invalidinput.msg")});
				}
			}else{
				if(userinput.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){
					me.setState({userLoginAllowed:false});
					me.props.showSignUp(me.state.loginType,me.state.billing_userid,me.props.from);
				}else{
					me.setState({submitButtonDisabled: false, serverMessage: me.rb("login.invalidinput.msg")});
				}
			}
		}

		existingUserId(){
			return(
					<FormGroup for="existing_userid" className="existuser">           
					<Label>        
					<span>{this.rb("existing.user")}</span>       
							<Input type="checkbox" id="existing_userid" name="existing_userid" checked={this.state.existing_userid} value={this.state.existing_userid} onChange={this.toggleChange} tabIndex="1"/>         
					  </Label>          
					 </FormGroup>
			)
		}

		newUserId(){
			var me=this;
			return(
				<FormGroup for="billing_userid">		
          <FormControlInput type="text" className="billing_userid" name="billing_userid" placeholder={this.rb("billing.userid")}
    			value={this.state.billing_userid} onChange={this.handleChange}
    			required pattern="^[a-z0-9]*$" minLength={6} maxLength={25} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="2"/>

					{(()=>{
						if(!me.state.eligible && !me.state.isverified && me.state.billing_userid.length>5){
						return(	<span className="userstatus" onClick={me.getUserStatus}>{this.rb("verify")}</span>)
						}
					 })()
					}
					{(()=>{
					//	console.log("existing_userid ",me.state.existing_userid);
						if(me.state.isverified && me.state.eligible && me.state.existing_userid){
							return	(<div className="error userstatusfbc">{this.rb("tchr.existuserid.valid")}</div>)
						}
						else if(!me.state.eligible && me.state.isverified && me.state.existing_userid){
							return (<div className="error userstatusfbw">{this.rb("tchr.existuserid.invalid")}</div>)
						}
						else if(me.state.isverified && me.state.eligible && !me.state.existing_userid){
							return	(<div className="error userstatusfbc">{this.rb("tchr.userid.valid")}</div>)
						}
						else if(!me.state.eligible && me.state.isverified && !me.state.existing_userid){
							return	(<div className="error userstatusfbw">{this.rb("tchr.userid.invalid")}</div>)
						}
					})()
					}

    			<FieldFeedbacks for="billing_userid">
    			<FieldFeedback when="valueMissing">{this.rb("billing.useridrequired")}</FieldFeedback>
					<FieldFeedback when={value => (value.length<6)}>{this.rb("tchrvalidate.userid.minimum",[6])}</FieldFeedback>
					<FieldFeedback when="patternMismatch">{this.rb("tchr.userid.pattern")}</FieldFeedback>
    			<FieldFeedback when="*" />
    			</FieldFeedbacks>
    			</FormGroup>
			)
		}
		
    renderBillingInformation(){
			var me=this;
    	HmEventRegistry.fireEvent("INITIATE_GA_EVENT");

    		//	console.log("product:::",this.productsJson);
    			return (
    			<div className="container row Billing josefin billing_form">

    			 <div className="col-12 order-2 col-sm-12 order-sm-2 col-md-12 order-md-2 col-lg-9 order-lg-1 nopadding pr-100">
    			{/*<div className="col-12 text-center  mt-20"><div className="heading">{this.rb("billing.information")}</div></div> */}
    			<FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
    			onSubmit={this.handleSubmit} noValidate>

						{this.existingUserId()}

						{this.newUserId()}

    			<FormGroup for="billing_name">		
    			<FormControlInput type="text" className="billing_name" name="billing_name" placeholder={this.rb("billing.fullname")}
    			value={this.state.billing_name} onChange={this.handleChange}
    			required minLength={1} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="3"/>
    			<FieldFeedbacks for="billing_name">
    			<FieldFeedback when="valueMissing">{this.rb("billing.namerequired")}</FieldFeedback>
    			<FieldFeedback when="*" />
    			</FieldFeedbacks>
    			</FormGroup>

    			<FormGroup for="billing_email">		
    			<FormControlInput type="text" className="billing_email" name="billing_email" placeholder={this.rb("profile.email_id")}
    			value={this.state.billing_email} onChange={this.handleChange}
    			required pattern="^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$"
    			minLength={1} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="4"/>
    			<FieldFeedbacks for="billing_email">
    			<FieldFeedback when="valueMissing">{this.rb("fpwd.emailrequired")}</FieldFeedback>
    			<FieldFeedback when="patternMismatch">{this.rb("fpwd.validemail")}</FieldFeedback>
    			<FieldFeedback when="*" />
    			</FieldFeedbacks>
    			</FormGroup>

    			<FormGroup for="billing_phone">
    			<FormControlInput type="billing_phone" className="billing_phone" name="billing_phone" placeholder={this.rb("register.phone")}
    			innerRef={phone => this.phone = phone}	
    			value={this.state.billing_phone} onChange={this.handleChange}	
    			pattern={this.validateMobilePattern()} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="5"/>
    			<FieldFeedbacks for="billing_phone">		
    			<FieldFeedback when="valueMissing">{this.rb("register.mobilerequired")}</FieldFeedback>
					{/* <FieldFeedback when={value => (value.length==0)}> {this.rb("register.mobilerequired")}</FieldFeedback> */}
    			<FieldFeedback when="patternMismatch">{this.rb("register.mobilenolength")}</FieldFeedback>
    			<FieldFeedback when={value => (value.length>0 && !/\d/.test(value))}>{this.rb("register.numbersonly")}</FieldFeedback>							 
    			<FieldFeedback when="*" />
    			</FieldFeedbacks>
    			</FormGroup>

    			<FormGroup for="billing_address">		
    			<FormControlInput type="text" className="billing_address" name="billing_address" placeholder={this.rb("billing.address")}
    			value={this.state.billing_address} onChange={this.handleChange}
    			required minLength={1} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="6"/>
    			<FieldFeedbacks for="billing_address">
    			<FieldFeedback when="valueMissing">{this.rb("billing.addressrequired")}</FieldFeedback>
    			<FieldFeedback when="*" />
    			</FieldFeedbacks>
    			</FormGroup>

    			<FormGroup for="billing_zipcode">		
    			<FormControlInput type="text" className="billing_zipcode" name="billing_zipcode" placeholder={this.rb("billing.zipcode")}
    			value={this.state.billing_zipcode} onChange={this.handleChange}
    			required minLength={1} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="7"/>
    			<FieldFeedbacks for="billing_zipcode">
    			<FieldFeedback when="valueMissing">{this.rb("billing.zipcoderequired")}</FieldFeedback>
    			<FieldFeedback when="*" />
    			</FieldFeedbacks>
    			</FormGroup>

    			<FormGroup for="billing_city">		
    			<FormControlInput type="text" className="billing_city" name="billing_city" placeholder={this.rb("billing.city")}
    			value={this.state.billing_city} onChange={this.handleChange}
    			required minLength={1} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="8"/>
    			<FieldFeedbacks for="billing_city">
    			<FieldFeedback when="valueMissing">{this.rb("billing.cityrequired")}</FieldFeedback>
    			<FieldFeedback when="*" />
    			</FieldFeedbacks>
    			</FormGroup>

    			<FormGroup for="billing_state">		
    			<FormControlInput type="text" className="billing_state" name="billing_state" placeholder={this.rb("billing.state")}
    			value={this.state.billing_state} onChange={this.handleChange}
    			required minLength={1} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="9"/>
    			<FieldFeedbacks for="billing_state">
    			<FieldFeedback when="valueMissing">{this.rb("billing.staterequired")}</FieldFeedback>
    			<FieldFeedback when="*" />
    			</FieldFeedbacks>
    			</FormGroup>

    			{/*<FormGroup for="billing_country">		
    			<FormControlInput type="text" className="billing_country" name="billing_country" placeholder={this.rb("billing.country")}
    			value={this.state.billing_country} onChange={this.handleChange}
    			required minLength={1} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="7"/>
    			<FieldFeedbacks for="billing_country">
    			<FieldFeedback when="valueMissing">{this.rb("billing.countryrequired")}</FieldFeedback>
    			<FieldFeedback when="*" />
    			</FieldFeedbacks>
    		</FormGroup>*/}

    		<Select						        
    		value={this.state.selectedCountryOption}
    		onChange={this.countryDropdownChange}
    		options={this.countryDpList}
    		onBlurResetsInput={false}
    		onSelectResetsInput={false}
    		autoFocus							 	
    		clearable={false}
    		rtl={false}
    		searchable={false}
    		required
    		/>
    		<p id="tax-message-2">{this.state.taxMsg2}</p>

    		<div className="server-messages">{this.state.serverMessage}</div>

    		<div  className="text-center"><button disabled={this.state.submitButtonDisabled} className="submitButton" data-ga={this.productCategoryInfo[this.state.selectedProductCategoryType+"-GA"]+" - "+this.state.selectedProductClassName+" - "+ "Purchase"}>{this.rb("billing.purchase")}</button></div>
    		<br />
    		<br />
    		</FormWithConstraints>	
    		</div>

    		{/* <div className="col-12 order-1 col-sm-12 order-sm-1 col-md-12 order-md-1 col-lg-6 order-lg-2 mb-50">
    		<div className="col-12 text-center  mt-20">
    		<div className="heading">{this.rb("product.ordersummary")}</div>
    		</div>
    		<div className="productBoxContainer">
    		{this.renderProductDetails()}
            </div> 
            
            </div>
            */}
    		
    	
    	</div>
    	);
}
renderProductDetails(){
	//console.log("this.productsJson::",this.productsJson);
	if(this.productsJson && Object.keys(this.productsJson).length > 0){			

		return(

			Object.keys(this.productsJson).map((item,index) => (
				<div className="productbox clearfix" key={index}>
				<div className="float-left productimg">
				<div className="g-img">
				<img src={"/"+JSON.parse(this.productsJson[item].productDetails)[0].thumbnail} alt=""/>
				</div>
				</div>
				<div className="float-left productcontent">
				<div className="g-text mb-0">
				{this.productsJson[item].ClassName}
				</div>
				<div className="g-text">
				<p>{this.rb(this.productsJson[item].productCategory)}</p>
				</div>
				<div>
				<p>
				<span className="greycolor">{this.rb("product.validity")} : &nbsp;</span>
				<span>{this.state.prod_validity}</span>
				</p>
				</div>
				<div>
				<span>{this.rb("product.price")} : &nbsp;</span>
				<span className="priceAmt"><h3>{this.state.prod_price}</h3></span>
				</div>
				<div id="tax-message-1">{this.state.taxMsg1}</div>
				</div>
				</div>
				))			
			);
	}
}

isProductSelected(){
	if(this.state.isProductSelected == false){
		return(	
			<div className="lineheight-40 josefin">
			<div className="text-center">
			{ReactHtmlParser(this.rb("register.noproducts.msg"))}
			</div>
			<div className="text-center josefin">
			{ReactHtmlParser(this.rb("register.noproducts.msg2"))}
			</div>
			<div className="text-center josefin">
			{ReactHtmlParser(this.rb("register.noproducts.msg3"))}
			</div>
			<div className="text-center josefin">
			OR
			</div>
			<div className="text-center">
			<a className="r-btn lineheight-20" href={'/products'}>{this.rb("product.browseproducts")}</a>
			</div>
			</div>

			);
		}
	}
	showOrderReview(){
		this.setState({"ModalContent":"review"});
		/*this.setState({"ModalContent":this.getOrderReview()});*/
		this.props.showOrderReview();
	}

	getOrderReview(){
		//console.warn("tchr products review",this.purchaseObj);
		var reviewData = {	
			userId:this.state.billing_userid.toLowerCase(),
			fullName:this.state.billing_name,					
			address:this.state.billing_address,					
			zip:this.state.billing_zipcode,					
			city:this.state.billing_city,					
			state:this.state.billing_state,
			country:this.state.selectedCountryOption.label || "",						
			phone:this.state.billing_phone,		
			email:this.state.billing_email,
			billingAddressLine1:this.state.billing_address,					
			billingAddressLine2:this.state.billing_address,	
			currency:this.purchaseObj.currency	,
			validity:(this.purchaseObj.validity	== "365") ? "1 Year" : this.purchaseObj.validity,
			productName:this.purchaseObj.productName,
			price:this.purchaseObj.productPrice,
			taxAmount:this.state.taxAmount,
			totalAmount:this.state.prod_price,
			basePrice:this.state.basePrice, 
			otherCharges:this.state.otherCharges,
			selectedProductCategoryType:this.productCategoryInfo[this.state.selectedProductCategoryType],
			selectedProductCategoryTypeGA:this.productCategoryInfo[this.state.selectedProductCategoryType+"-GA"],
			selectedProductClassName:this.state.selectedProductClassName
		}

		return(
		 <OrderReview hideReviewModal={this.hideReviewModal} reviewData={reviewData} proceedPay={this.proceedPay}/>
		 );
	}

	renderHiddenForm(){
return(
	<form id="doPayForm" className="hidden" method="post" target="_top" action={this.getUrlFor("OPS_DO_PAY")}>
	<input type="hidden" name="userId" value="" />  
	<input type="hidden" name="appName" value="" />
	<input type="hidden" name="_appId" value="" />
	<input type="hidden" name="sessionId" value=""/>
	<input type="hidden" name="fullName" value=""/>
	<input type="hidden" name="address" value="" />
	<input type="hidden" name="zip" value=""/>
	<input type="hidden" name="city" value="" />
	<input type="hidden" name="state" value="" />
	<input type="hidden" name="countryCode" value="" />
	<input type="hidden" name="country" value="" />
	<input type="hidden" name="email" value="" />
	<input type="hidden" name="phone" value="" />
	<input type="hidden" name="language" value="" />
	<input type="hidden" name="productList" value=""/>
	<input type="hidden" name="currency" value="" />
	<input type="hidden" name="payload" value="" />
	<input type="submit" value="submit" id="paySubmit" />
	</form>
)
	}

	renderForm(){
		let sessionId = (this.state.sessionId && this.state.sessionId.length>0) ? true : false
		
		if(this.props.ModalShow && (this.state.ModalContent === "billing") && sessionId){
			return(
			<div>
					{this.renderBillingInformation()}
		
				</div>
			)
		}else if(this.props.ModalShow && (this.state.ModalContent === "review") && sessionId){
			return(
				<div>
					{this.getOrderReview()}
					</div>
				)
		}else{
			return null
		}
	}

	render() {
		HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
		return (
		<div id="tchbillingform">
			{this.renderHiddenForm()}
			{this.renderForm()}
			</div>
		);
	}
}

export default BillingForm;


// WEBPACK FOOTER //
// ./src/views/purchase/BillingForm.js